"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taxLabelArray = exports.TaxEnum = void 0;
var TaxEnum;
(function (TaxEnum) {
    TaxEnum[TaxEnum["ZERO_PERCENT"] = 0] = "ZERO_PERCENT";
    TaxEnum[TaxEnum["FIVE_PERCENT"] = 5] = "FIVE_PERCENT";
    TaxEnum[TaxEnum["SEVEN_PERCENT"] = 7] = "SEVEN_PERCENT";
    TaxEnum[TaxEnum["SIXTEEN_PERCENT"] = 16] = "SIXTEEN_PERCENT";
    TaxEnum[TaxEnum["EIGHTEEN_PERCENT"] = 18] = "EIGHTEEN_PERCENT";
    TaxEnum[TaxEnum["NINETEEN_PERCENT"] = 19] = "NINETEEN_PERCENT";
    TaxEnum[TaxEnum["TWENTY_PERCENT"] = 20] = "TWENTY_PERCENT";
    TaxEnum[TaxEnum["TWENTYSEVEN_PERCENT"] = 27] = "TWENTYSEVEN_PERCENT";
})(TaxEnum || (exports.TaxEnum = TaxEnum = {}));
exports.taxLabelArray = [
    { label: "0 %", value: TaxEnum.ZERO_PERCENT },
    { label: "5 %", value: TaxEnum.FIVE_PERCENT },
    { label: "7 %", value: TaxEnum.SEVEN_PERCENT },
    { label: "16 %", value: TaxEnum.SIXTEEN_PERCENT },
    { label: "18 %", value: TaxEnum.EIGHTEEN_PERCENT },
    { label: "19 %", value: TaxEnum.NINETEEN_PERCENT },
    { label: "20 %", value: TaxEnum.TWENTY_PERCENT },
    { label: "27 %", value: TaxEnum.TWENTYSEVEN_PERCENT },
];
